exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tweet[data-v-bb6e9438]{width:18rem;height:18rem;overflow:scroll}", ""]);

// exports
